import {defterUnitName} from "./permission";
import {EntegratorConf} from "../constants";

export const TabForService = {
    "EARSIVFATURA": ["SiparisBilgileri", "IrsaliyeBilgileri", "InternetSatisBilgileri", "TasiyiciBilgileri", "Masraflar", "EkDokumanlar","EkBilgiler"],
    "EGIDERPUSULASI": ["SiparisBilgileri", "IrsaliyeBilgileri", "InternetSatisBilgileri", "TasiyiciBilgileri", "Masraflar"],
    "TEMELFATURA": ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri","EkDokumanlar","EkBilgiler"],
    "TICARIFATURA": ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri","EkDokumanlar","EkBilgiler"],
    "EBELGE": ["IrsaliyeBilgileri","IadeBilgileri" /*,"SiparisBilgileri", "InternetSatisBilgileri", "TasiyiciBilgileri", "Masraflar"*/],
    "SGK": ["SiparisBilgileri", "IrsaliyeBilgileri", "SGKBilgileri", "OdemeBilgileri"],
    "YOLCUBERABERFATURA": ["AraciKurumBilgileri"],
    "IHRACAT": ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri","EkDokumanlar"],
    "HKS" : ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri", "Masraflar"],
    "KAMU" : ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri", "Masraflar","EkDokumanlar","EkBilgiler"],
    "ENERJI": ["SiparisBilgileri", "IrsaliyeBilgileri", "OdemeBilgileri","EkDokumanlar","EkBilgiler"],
    "ILAC_TIBBICIHAZ" : []
};

export const InvoiceLineEnum = {
    0: "itemName",
    1: "quantity",
    2: "unit",
    3: "unitPrice",
    4: "allowancePercentage",
    5: "allowanceAmount",
    6: "kdvPercentage",
    7: "kdvAmount",
    8: "lineExplanation",
    9: "gtip",
    10: "actualPackageId",
    11: "packageType",
    12: "actualPackageQuantity",
    13: "packageBrand",
    14: "deliveryTerms",
    15: "shipmentId",
    16: "transportModeCode",
    17: "country",
    18: "city",
    19: "citySubdivion",
    20: "streetName",
    21: "postalZone",
    22: "buildingName",
    23: "buildingNumber"
};

export const BelgeLineEnum = {
    0: "itemName",
    1: "quantity",
    2: "unit",
    3: "unitPrice",
    4: "allowancePercentage",
    5: "allowanceAmount",
    6: "kdvPercentage",
    7: "kdvAmount",
    8: "lineExplanation",
    9: "gtip",
    10: "actualPackageId",
    11: "packageType",
    12: "actualPackageQuantity",
    13: "packageBrand",
    14: "deliveryTerms",
    15: "shipmentId",
    16: "transportModeCode",
    17: "country",
    18: "city",
    19: "citySubdivion",
    20: "streetName",
    21: "postalZone",
    22: "buildingName",
    23: "buildingNumber"
};

export const SerbestVoucherEnum = {
    0: "documentNo",
    1: "issueDate",
    2: "vknTckn",
    3: "formattedName",
    4: "givenName",
    5: "familyName",
    6: "itemName",
    7: "citySubdivisionName",
    8: "cityName",
    9: "tevkifatAmount",
    10: "gercekAmount",
    11: "gvStoppageCode",
    12: "percentage",
    13: "lineExtensionAmount",
    14: "note",

};

export const DespatchEnum = {
    0: "documentNo",
    1: "givenName",
    2: "familyName",
    3: "vknTckn",
    4: "cityName",
    5: "citySubdivisionName",
    6: "postboxAlias",
    7: "sourceUrn",
    8: "issueDate",
    9: "issueTime",
    10: "formattedName",
    11: "deliveryStreetName",
    12: "deliveryPostalZone",
    13: "deliveryCitySubdivision",
    14: "deliveryCity",
    15: "deliveryType",
    16: "carrierId",
    17: "carrierTitle",
    18: "driverFirstName",
    19: "driverFamilyName",
    20: "licensePlateID",
    21: "actualDespatchDatetime",
    22: "actualDespatchDatehour",
    23: "itemName",
    24: "quantity",
    25: "unit",
    26: "unitPrice",
    27: "note",
    28: "streetName",
    29: "orderReferenceNumber",
    30: "orderReferenceDate"
};

export const DespatchLineEnum = {
    0: "itemName",
    1: "quantity",
    2: "unit",
    3: "unitPrice",
    4: "kunyeNo",
    5: "innerItemCount",
    6: "outstandingQuantity",
    7: "outstandingReason",
    8: "buyersItemIdentification",
    9: "orderLineReference",
    10: "barcode",
    11: "lineExplanation",

};

export const StockEnum = {
    0: "stockCode",
    1: "stockName",
    2: "kdvBuy",
    3: "kdvSell",
    4: "priceBuy",
    5: "priceSell",
    6: "currency",
    7: "unit",
    8: "alias",
    9: "explanation",
    10: "kdvPurchaseExemption",
    11: "kdvSellExemption",
    12: "gtip"
};

export const SigortaEnum = {
    0: "documentNo",
    1: "issueDate",
    2: "issueTime",
    3: "documentCurrencyCode",
    4: "paymentExchangeRate",
    5: "vknTckn",
    6: "formattedName",
    7: "givenName",
    8: "familyName",
    9: "postboxAlias",
    10: "citySubdivisionName",
    11: "cityName",
    12: "countryName",
    13: "streetName",
    14: "taxOffice",
    15: "itemName",
    16: "productCommissionPrice",
    17: "cancelCommissionPrice",
    18: "periodStartDateTime",
    19: "periodEndDateTime",
    20: "note"
};

export const ExternalCustomerEnum = {
    0: "vkn_tckn",
    1: "formatted_name",
    2: "given_name",
    3: "middle_name",
    4: "family_name",
    5: "commerce_chamber",
    6: "city",
    7: "tax_office",
    8: "mersis_number",
    9: "trade_registration_number",
    10: "customer_type",
    11: "initial_balance",
    12: "customer_risk_limit",
    13: "address_name",
    14: "contact_person",
    15: "country_name",
    16: "city_name",
    17: "city_subdivision_name",
    18: "web_site",
    19: "email",
    20: "telephone",
    21: "fax",
    22: "postal_address_region",
    23: "building_name",
    24: "building_no",
    25: "postal_address_room",
    26: "postal_zone",
    27: "bank_name",
    28: "iban",
    29: "is_foreign_customer"
};

export const VoucherEnum = {
    0: "documentNo",
    1: "issueDate",
    2: "fullName",
    3: "vknTckn",
    4: "fullAddress",
    5: "itemName",
    6: "quantity",
    7: "unitPrice",
    8: "gvStoppageCode",
    9: "lineExtensionAmount",
    10:"borsaAmount",
    11:"meraAmount",
    12:"sgkAmount",
    13:"unit",
    14:"stockCode"

};

export const InvoiceEnum = {
    0: "documentNo",
    1: "profileId",
    2: "invoiceTypeCode",
    3: "issueDate",
    4: "issueTime",
    5: "destinationUrn",
    6: "sourceUrn",
    7: "email",
    8: "documentCurrencyCode",
    9: "paymentExchangeRate",
    10: "vknTckn",
    11: "formattedName",
    12: "givenName",
    13: "familyName",
    14: "citySubdivisionName",
    15: "cityName",
    16: "countryName",
    17: "streetName",
    18: "taxOffice",
    19: "itemName",
    20: "quantity",
    21: "unitPrice",
    22: "unit",
    23: "iskontoPercentage",
    24: "kdvPercentage",
    25: "exemptionReasonCode",
    26: "note",
    27: "referenceId",
    28: "referenceIssueDate",
    29: "gtip",
    30: "tevkifatAmount",
    31: "internetSaleArea",
    32: "webSite",
    33: "paymentMethod",
    34: "paymentDetails",
    35: "paymentDate",
    36: "carrierFirstName",
    37: "carrierFamilyName",
    38: "carrierTitle",
    39: "carrierVknTckn",
    40: "deliveryDate",
    41: "telephone"
};

export const BelgeEnum = {
    0: "documentNo",
    1: "documentTypeCode",
    2: "issueDate",
    3: "issueTime",
    4: "email",
    5: "documentCurrencyCode",
    6: "paymentExchangeRate",
    7: "vknTckn",
    8: "formattedName",
    9: "givenName",
    10: "familyName",
    11: "citySubdivisionName",
    12: "cityName",
    13: "countryName",
    14: "streetName",
    15: "taxOffice",
    16: "itemName",
    17: "quantity",
    18: "unitPrice",
    19: "unit",
    20: "iskontoPercentage",
    21: "kdvPercentage",
    22: "exemptionReasonCode",
    23: "note",
    24: "referenceId",
    25: "referenceIssueDate",
    26: "tevkifatAmount",
};

export const UserRightsEnum = {

    invoice : {
        view: "invoice_view",
        create: "invoice_create",
        update: "invoice_update",
        delete: "invoice_delete",
        send: "invoice_send",
        sign:"invoice_sign",
        viewIncoming: "invoice_view_incoming",
        updateIncoming: "invoice_update_incoming",
        respondIncoming: "invoice_respond_incoming",
    },

    besbinotuzbin: {
        view: "besbinotuzbin_view",
        create: "besbinotuzbin_create",
        update: "besbinotuzbin_update",
        delete: "besbinotuzbin_delete",
        send: "besbinotuzbin_send",
        viewIncoming: "besbinotuzbin_view_incoming"
    },

    earchive: {
        view : "earchive_view",
        create: "earchive_create",
        update: "earchive_update",
        delete: "earchive_delete",
        send: "earchive_send",
        sign:"earchive_sign",
        sendReport: "earchive_send_report",
        viewReport: "earchive_view_report",
    },

    okc: {
        viewReport: "okc_view_report",
        createReport: "okc_create_report",
        editReport: "okc_edit_report",
        sendReport: "okc_send_report",
        deleteReport: "okc_delete_report",
    },

    expenseNote: {
        view: "expensenote_view",
        update: "expensenote_update",
        delete: "expensenote_delete",
        create: "expensenote_create",
        send: "expensenote_send",
    },

    newExpenseNote: {
        view: "new_expense_note_view",
        update: "new_expense_note_update",
        delete: "new_expense_note_delete",
        create: "new_expense_note_create",
        send: "new_expense_note_send"
    },

    ekonnektor: {
        view: "ekonnektor_view",
        update: "ekonnektorupdate",
        delete: "ekonnektordelete",
        create: "ekonnektorcreate",
        send: "ekonnektorsend"
    },

    despatch:{
        view: "despatch_view",
        viewIncoming: "despatch_view_incoming",
        create: "despatch_create",
        update: "despatch_update",
        delete: "despatch_delete",
        send: "despatch_send",
        sign: "despatch_sign",
        respondIncoming: "despatch_respond_incoming",
        updateIncoming: "despatch_update_incoming",
    },

    voucher:{
        mmView: "voucher_mm_view",
        mmCreate: "voucher_mm_create",
        mmUpdate: "voucher_mm_update",
        mmDelete: "voucher_mm_delete",
        mmSend: "voucher_mm_send",
        mmSign: "voucher_mm_sign",
        smmView: "voucher_smm_view",
        smmCreate:"voucher_smm_create",
        smmUpdate: "voucher_smm_update",
        smmDelete:"voucher_smm_delete",
        smmSend:"voucher_smm_send",
        smmSign:"voucher_smm_sign",
    },

    exchange:{
        view: "exchange_view",
        create:"exchange_create",
        update: "exchange_update",
        delete:"exchange_delete",
        send:"exchange_send",
        sign:"exchange_sign",
    },

    settings:{
        prefixCode:{
            create: "settings_prefixcode_create",
            update: "settings_prefixcode_update",
            delete: "settings_prefixcode_delete",
        },
        xslt: {
            view: "settings_xslt_view",
            create: "settings_xslt_create",
            update: "settings_xslt_update",
            delete: "settings_xslt_delete",
        },
        inboxWarning:{
            update: "settings_inboxwarning_update",
            create: "settings_inboxwarning_create",
        },
        tagList:{
            create: "settings_taglist_create",
            delete: "settings_taglist_delete",
        },
        stockCard:{
            create: "settings_stockcard_create",
            update: "settings_stockcard_update",
            delete: "settings_stockcard_delete",
        },
        externalCustomer:{
            create: "settings_externalcustomer_create",
            update: "settings_externalcustomer_update",
            delete: "settings_externalcustomer_delete",
        },
        user:{
            sendMail: "settings_user_send_mail",
            create: "settings_user_create",
            update: "settings_user_update",
            delete: "settings_user_delete",
        }
    },
    entegratorSettings:{
        credit:{
            add:"entegrator_settings_credit_add",
        },
        accessCustomerPortal: "access_customer_portal",
        showDocumentStatus: "show_document_status",
        accessEnvelopeQuery: "access_envelope_query",
        customerXsltManagement: "customer_xslt_management",
    },

    receipt:{
        view: "receipt_view",
        update: "receipt_update",
        delete:"receipt_delete",
        send:"receipt_send",
    },
    sigorta:{
        view: "sigorta_view",
        update: "sigorta_update",
        delete:"sigorta_delete",
        send:"sigorta_send",
        create: "sigorta_create",
    },
};

export const serviceTypeEnum = {
    E_ARSIV: 1,
    E_FATURA: 2,
    E_DEFTER: 3,
    SAKLAMA: 4,
    E_DEFTER_YUKLEME: 5,
    E_IRSALIYE: 6,
    SMM: 7,
    MM: 8,
    MALI_RAPOR_ESKI_OKC: 9,
    MALI_RAPOR_YENI_OKC: 10,
    E_ADISYON:12,
    KEP_IK: 77,
    DEFTER_KONTROL: 88,
    ON_MUHASEBE: 99,
    E_ARSIV_KASA: 111,
    E_DEFTER_IKINCIL_KOPYA : 121,
    E_GIDER_PUSULASI : 122,
    E_KONNECTOR : 123,
    E_ARSIV_BES_BIN_OTUZ_BIN:124,
    E_DOVIZ:11,
    E_SIGORTA: 125,
    E_TICARET: 140
};

export const contractRateTypeEnum = {
    INVOICED: 1,
    PREPAID: 2,
};

export const EntegratorIdentifiers = {
    KOLAYSOFT: "5750464002",
    SMART: "7720709620",
    VEGA: "9240925043",
    ZIRVE: "9980847980",
    UNIVERA: "3250176843",
    MIKROKOM: "6210533887",
    HIZLI: "4620553774",
    FARMAKOM: "3850010207",
    DEVATEK: "2940559901",
    MEDIFATURA: "6130914493",
    TURKKEP: "6080475329",
    MBT: "6130914493",
    BYM: "1950703297",
    AKTIF: "0421017784",
}

export const ExternalCustomerMainType = {
    Normal: "NORMAL",
    Foreign: "FOREIGN",
    DespatchMixed: "DESPATCH_MIXED"
};

export const SmsProviders = {
    NETGSM: {label: "NETGSM", value: "NETGSM"}
};

export const DocumentFrom = {
    PORTAL: "PORTAL",
    ELECTRON: "ELECTRON",
    CONNECTOR: "CONNECTOR",
    MOBILE_APP: "MOBILE_APP"
};

export const AuthPageType = {
    TURMOB: {
        fetchUrl: "/turmob/auth/getTurmobAuth",
        saveUrl: "/turmob/auth/saveTurmobAuth",
        deleteUrl: "/turmob/auth/deleteTurmobAuth"
    },
    UTS: {
        fetchUrl: "/uts/auth/getUtsAuth",
        saveUrl: "/uts/auth/saveUtsAuth",
        deleteUrl: "/uts/auth/deleteUtsAuth"
    },
    DBS: {
        fetchUrl: "/dbs/auth/getDBSAuthWithoutCaptcha",
        saveUrl: "/dbs/auth/saveDbsAuthentication",
        deleteUrl: "/dbs/auth/deleteDbsAuth"
    },
    INTERAKTIFVD: {
        fetchUrl: "/ivd/auth/getIvdAuth",
        saveUrl: "/ivd/auth/saveIvdAuth",
        deleteUrl: "/ivd/auth/deleteIvdAuth",
        signOutUrl: "ivd/auth/signOut"
    },
    CICEKSEPETI: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    },
    TRENDYOL: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    },
    HEPSIBURADA: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    },
    N11: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    },
    PAZARAMA: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    },
    IKAS: {
        fetchUrl: "/eCommerces/auth/getECommercesAuth",
        saveUrl: "/eCommerces/auth/saveAuth",
        deleteUrl: "/eCommerces/auth/deleteECommerceAuth"
    }
}

export const VoyageStatusEnum = {
    UNPRINTED: {label: "YAZDIRILMAMIŞ", value: "UNPRINTED"},
    PRINTED: {label: "YAZDIRILMIŞ", value: "PRINTED"},
    CANCELLED: {label: "İPTAL EDİLMİŞ", value: "CANCELLED"},
    SEND: {label: "GÖNDERİLMİŞ", value: "SEND"}
}

export const DepoType = {
    SELCUK: {
        title: "Selçuk",
        endpointUrl: "selcuk",
        enumName: "SELCUK"
    },

    AS: {
        title: "As",
        endpointUrl: "as",
        enumName: "AS"
    },

    HEDEF_ALLIANCE: {
        title: "Hedef Alliance",
        endpointUrl: "hedef",
        enumName: "HEDEF"
    },

    NEVZAT: {
        title: "Nevzat",
        endpointUrl: "nevzat",
        enumName: "NEVZAT"
    },

    IMAJ: {
        title: "İmaj",
        endpointUrl: "imaj",
        enumName: "IMAJ"
    },

    AFYON: {
        title: "Afyon",
        endpointUrl: "afyon",
        enumName: "AFYON"
    },

    DENGE: {
        title: "Denge",
        endpointUrl: "denge",
        enumName: "DENGE"
    },

    SANCAK: {
        title: "Sancak",
        endpointUrl: "sancak",
        enumName: "SANCAK"
    },

    MADEN: {
        title: "Maden",
        endpointUrl: "maden",
        enumName: "MADEN"
    },

    KIZILAY: {
        title: "Kızılay",
        endpointUrl: "kizilay",
        enumName: "KIZILAY"
    }
}

export const ChemistWarehouseQueryType = {
    ALL: {label: "Tümü", value: "ALL"},
    INCLUDED_WAREHOUSE: {label: "Depo Dahil", value: "INCLUDED_WAREHOUSE"},
    EXCLUDED_WAREHOUSE: {label: "Depo Hariç", value: "EXCLUDED_WAREHOUSE"},
    ONLY_WAREHOUSE: {label: "Sadece Depo", value: "ONLY_WAREHOUSE"}
}

export const CustomerBankType = {
    SGK: "SGK",
    KAMU: "KAMU",
    OTHER: "OTHER"
}

export const VukApplicationState = {
    // USER_CREATION:"",
    // SERVICE_ACTIVATING: "",
    // START_APPLICATION: "",
    AUTOMATION_SELECTION: "AUTOMATION_SELECTION",
    SPONSOR_SELECTION: "SPONSOR_SELECTION",
    PAYMENT: "PAYMENT",
    BANK_CONFIRMATION: "BANK_CONFIRMATION ONAYI",
    GIB_ACTIVATION: "GIB_ACTIVATION",
    WAITING_GIB_APPROVE_DOCUMENT: "WAITING_GIB_APPROVE_DOCUMENT",
    SIPAY: "SIPAY",
    PAVO_ACTIVATION: "PAVO_ACTIVATION",
    VUK_PORTAL_ACTIVATION: "VUK_PORTAL_ACTIVATION",
    DELIVERY_PROCESS: "DELIVERY_PROCESS",
    COMPLETED: "COMPLETED..",
}

export const VukApplicationTrackingStatus = {
    BANKA_BASVURUSU_BEKLIYOR: "BANKA_BASVURUSU_BEKLIYOR",
    OTOMASYON_ENTEGRASYONU_BEKLENIYOR: "OTOMASYON_ENTEGRASYONU_BEKLENIYOR",
    BKM_ONAY_BEKLIYOR: "BKM_ONAY_BEKLIYOR",
    MAIL_EDONUSUM_AC: "MAIL_EDONUSUM_AC",
    PAVO_AC: "PAVO_AC",
    EVRAK_CIHAZ_YUKLE: "EVRAK_CIHAZ_YUKLE",
    PAVO_ONAY_BEKLIYOR: "PAVO_ONAY_BEKLIYOR",
    PAVO_ONAYLADI: "PAVO_ONAYLADI",
    KARGOYA_VERILECEK: "KARGOYA_VERILECEK",
    KARGODA: "KARGODA",
    ECZACI_POS_AC: "ECZACI_POS_AC",
    RANDEVUSUZ_KURULUM: "RANDEVUSUZ_KURULUM",
    RANDEVULU_KURULUM: "RANDEVULU_KURULUM",
    SON: "SON",
    IPTAL: "IPTAL"
}

export const CreditPoolType = {
    DOCUMENT_COUNT: {label: "Kontör", value: "DOCUMENT_COUNT"},
    SPACE_SIZE: {label: defterUnitName(EntegratorConf.identifier), value: "SPACE_SIZE"}
}

export const FisStateEnum = {
    0 : "",
    1 : "IŞLEMDE" ,
    2 : "MUHASEBELEŞTİ"
}

export const FisType = {
    fisInbox : "EInvoiceInboxAccountingReceipt",
    fisOutbox : "EInvoiceOutboxAccountingReceipt" ,
    archiveAccountingReceipt : "ArchiveAccountingReceipt"
}

export const PaymentType = {
    ALL: {label: "Tümü", value: null},
    ERP_PAYMENT:{label:"ERP Ödemesi",value: "ERP_PAYMENT"},
    DEALER_PAYMENT: {label:"Bayi Toplu Kontor", value: "DEALER_PAYMENT"},
    EBELGE: {label: "EBELGE", value:"EBELGE"},
    CUSTOMER_PAYMENT: {label: "Müşteri Alımı" , value:"CUSTOMER_PAYMENT"},
    PAY_FOR_CUSTOMER: {label:"Bayi Müşteri Adına Öder" , value: "PAY_FOR_CUSTOMER"},
    EXTERNAL_PAYMENT_OTHER:{label:"Harici Ödeme",value: "EXTERNAL_PAYMENT_OTHER"},
    SPONSOR_SELECTION: "SPONSOR SEÇİM",
    PAYMENT: "ÖDEME",
    BANK_CONFIRMATION: "BANKA ONAYI",
    GIB_ACTIVATION: "GİB AKTİVASYON",
    PAVO_ACTIVATION: "KARGO",
    VUK_PORTAL_ACTIVATION: "KARGO",
    DELIVERY_PROCESS: " KARGO",
    COMPLETED: "tamamlanmıştır.."
}

export const eCommerces = {
    TRENDYOL: "TRENDYOL",
    CICEKSEPETI: "CICEKSEPETI",
    HEPSIBURADA: "HEPSIBURADA",
    N11: "N11",
    PAZARAMA: "PAZARAMA",
    IKAS: "IKAS"
}

export const DvdSms = {
    EDDefterBasvuruDilekce: "EDefterBasvuruDilekce"
};

export const PdfNameEnum = {
    ALICI_VEYA_GONDERICI_DOCUMENT_ID: "Alıcı/Gönderici Ünvan ve Doküman No",
    ALICI_VEYA_GONDERICI_DOCUMENT_UUID: "Alıcı/Gönderici Ünvan ve ETTN",
    DOCUMENT_ID: "Doküman No",
    DOCUMENT_ID_DOCUMENT_UUID: "Doküman No ve ETTN",
    DOCUMENT_UUID: "ETTN",
    DOCUMENT_UUID_DOCUMENT_ID: "ETTN ve Doküman No"
};

